import * as React from "react";
import { Accordeon, Button, Classes, Dialog, Intent, Tree, } from "@focus/focusUI";
import "./AccesibilityList.scss";
import FiltrableSelector from "../FiltrableSelector";
import _ from "lodash";
import { userEnumCode } from "@focus/interfaces/lib/common/Users";
export class AccesibilityList extends React.Component {
    constructor(props) {
        super(props);
        this.getNodeAtPath = (schema, path) => {
            return path.reduce((accItem, currentValue) => accItem[currentValue], schema);
        };
        this.changeFieldValue = (path, field, newValue) => {
            const copy = _.cloneDeep(this.state.structure);
            const nodeInSchema = this.getNodeAtPath(copy, path);
            nodeInSchema[field] = newValue;
            this.setState({ structure: copy });
        };
        this.createChildrenNode = (title, key, type, path, availableOptions) => {
            const nodeInSchema = this.getNodeAtPath(this.state.structure, path);
            return (React.createElement("ul", { className: "ul_access_list", role: "list", "aria-label": "accessibility-list" },
                React.createElement("li", null,
                    React.createElement("table", null,
                        React.createElement("tbody", null,
                            React.createElement("tr", { className: "access_list-row" },
                                React.createElement("td", { className: "access_list-name" },
                                    " ",
                                    React.createElement(Accordeon, { title: title })),
                                React.createElement("td", { className: "access_list-short" },
                                    React.createElement("span", { style: { marginLeft: "10px" } }, key)),
                                React.createElement("td", { className: "access_list-type" },
                                    React.createElement("span", { style: { marginLeft: "10px" } }, type)),
                                React.createElement("td", { className: "access_list-buttons", onClick: (e) => e.stopPropagation() },
                                    React.createElement(FiltrableSelector, { value: availableOptions[nodeInSchema["ui:visibilityLevel"] - 1], onItemSelect: (e) => {
                                            this.changeFieldValue(path, "ui:visibilityLevel", parseInt(userEnumCode[e]));
                                        }, items: availableOptions, expand: false })),
                                React.createElement("td", { className: "access_list-buttons", onClick: (e) => e.stopPropagation() },
                                    React.createElement(FiltrableSelector, { value: availableOptions[nodeInSchema["ui:editableLevel"] - 1], onItemSelect: (e) => this.changeFieldValue(path, "ui:editableLevel", parseInt(userEnumCode[e])), items: availableOptions, expand: false }))))))));
        };
        this.createNodeHeader = () => (React.createElement("ul", { className: "ul_access_list", role: "list", "aria-label": "accessibility-list" },
            React.createElement("li", null,
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", { className: "access_list-row" },
                            React.createElement("td", { className: "access_list-name" },
                                " ",
                                React.createElement(Accordeon, { title: "TITLE" })),
                            React.createElement("td", { className: "access_list-short" },
                                React.createElement("span", { style: { marginLeft: "10px" } },
                                    React.createElement("strong", null, "KEY"))),
                            React.createElement("td", { className: "access_list-type" },
                                React.createElement("span", { style: { marginLeft: "10px" } },
                                    React.createElement("strong", null, "TYPE"))),
                            React.createElement(React.Fragment, null,
                                React.createElement("td", { className: "access_list-buttons" },
                                    React.createElement("span", { style: { marginLeft: "10px" } },
                                        React.createElement("strong", null, "VISIBLE"))),
                                React.createElement("td", { className: "access_list-buttons" },
                                    React.createElement("span", { style: { marginLeft: "10px" } },
                                        React.createElement("strong", null, "EDITABLE"))))))))));
        this.handleCollapse = (id) => {
            const collapsed = Object.assign({}, this.state.collapsed);
            collapsed[id] = !collapsed[id];
            this.setState({ collapsed });
        };
        this.expansionHandler = (node) => {
            if (node.childNodes.length > 0) {
                this.handleCollapse(node.id);
            }
        };
        this.saveAccessList = (structure) => {
            const configParsed = JSON.parse(JSON.stringify(structure, (k, v) => k === "ui:order" || k === "ui:field" || k === "title" ? undefined : v));
            this.props.saveAction(configParsed);
        };
        let collapsed = [];
        flattenSchema(this.props.config).forEach((e) => {
            collapsed[e] = false;
        });
        this.state = {
            collapsed,
            structure: this.props.config,
        };
    }
    getAccessList(uischema) {
        return this.configToTree(uischema);
    }
    configToTreeAux(uischema, path, availableOptions) {
        let tree = [];
        for (let key in uischema) {
            let childNodes = [];
            if (uischema[key] && uischema[key]["ui:field"]) {
                let newPath = path.slice();
                newPath.push(key);
                if (uischema[key]["ui:order"]) {
                    childNodes = this.configToTreeAux(uischema[key], newPath, availableOptions);
                }
                tree.push({
                    id: key,
                    label: this.createChildrenNode(uischema[key].title ? uischema[key].title : key, key, uischema[key]["ui:field"], newPath, availableOptions),
                    childNodes,
                    isExpanded: this.state.collapsed[key],
                    hasCaret: childNodes.length > 0,
                });
            }
        }
        return tree;
    }
    configToTree(uiSchema) {
        let tree = [];
        const availableOptions = Object.keys(userEnumCode);
        for (let key in uiSchema) {
            let childNodes = [];
            if (uiSchema[key] && uiSchema[key]["ui:field"]) {
                let path = [key];
                if (uiSchema[key]["ui:order"]) {
                    childNodes = this.configToTreeAux(uiSchema[key], path, availableOptions);
                }
                tree.push({
                    id: key,
                    label: this.createChildrenNode(uiSchema[key].title ? uiSchema[key].title : key, key, uiSchema[key]["ui:field"], [key], availableOptions),
                    childNodes,
                    isExpanded: this.state.collapsed[key],
                    hasCaret: childNodes.length > 0,
                });
            }
        }
        tree.unshift({
            id: "HEADER",
            label: this.createNodeHeader(),
            childNodes: [],
            hasCaret: false,
        });
        return tree;
    }
    render() {
        const { structure } = this.state;
        return (React.createElement(Dialog, { isOpen: this.props.isOpen, style: { width: "auto" }, isCloseButtonShown: false, title: "Accessibility and visibility configuration" },
            React.createElement("div", { className: Classes.DIALOG_BODY, "data-testid": "accessibility-list-body" },
                React.createElement("div", { className: "access_list-container" },
                    React.createElement(Tree, { contents: this.getAccessList(structure), onNodeCollapse: (node) => this.expansionHandler(node), onNodeExpand: (node) => this.expansionHandler(node), onNodeClick: (node) => this.expansionHandler(node) }))),
            React.createElement("div", { className: Classes.DIALOG_FOOTER },
                React.createElement("div", { className: Classes.DIALOG_FOOTER_ACTIONS },
                    React.createElement(Button, { intent: Intent.PRIMARY, onClick: () => this.saveAccessList(this.state.structure) }, "Save"),
                    React.createElement(Button, { onClick: () => this.props.handleOpenDialog(false) }, "Close")))));
    }
}
function flattenArray(uischema) {
    const list = [];
    for (let key in uischema) {
        if (uischema[key] && uischema[key]["ui:field"]) {
            list.push(key);
            if (uischema[key]["ui:order"]) {
                const newArray = flattenArray(uischema[key]);
                newArray.forEach((subEl) => list.push(subEl));
            }
        }
    }
    return list;
}
function flattenSchema(uischema) {
    const noArrays = flattenArray(uischema);
    return noArrays;
}
//# sourceMappingURL=AccesibilityList.js.map